import LinkPreviewPlugin from './plugin/LinkPreviewPlugin';
import linkPreviewPluginTrigger from './utils/linkPreviewPluginTrigger';
import createLazyPlugin, {
    LazyPlugin,
    LazyPluginClass,
} from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { lazyCreateLinkPreview } from 'owa-link-preview';
import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "LinkPreview" */ './plugin/LinkPreviewPlugin')
);

export let LazyLinkPreviewPluginClass: LazyPluginClass<LinkPreviewPlugin> = createLazyPlugin(
    lazyModule,
    m => m.default,
    'LinkPreview',
    linkPreviewPluginTrigger
);

export type LazyLinkPreviewPlugin = LazyPlugin<LinkPreviewPlugin>;
export { lazyCreateLinkPreview };
